'use strict';

/**
 * Deferred implementation.
 *
 * Proxies to jQuery.Deferred.
 *
 * @class Deferred
 * @extends jQuery.Deferred
 * @constructor
 * @module Core
 */
export class Deferred {
    private def:JQueryDeferred<any>;

    constructor() {
        this.def = $.Deferred();
    }

    /**
     * Provides a way to execute callback functions based on one or more objects, usually Deferred objects that
     * represent asynchronous events.
     *
     * @method when
     * @return {Deferred.Promise}
     */
    static when() {
        return $.when.apply(window, arguments);
    }

    /**
     * Returns a promise that is resolved when all input promises have been resolved or failed
     *
     * @method whenAll
     * @return {Deferred.Promise}
     */
    static whenAll(...args):JQueryDeferred<any> {
        var promise = $.Deferred();
        var remaining = args.length;

        _.each(args, (val)=> {
            val.always(()=> {
                remaining--;
                if (remaining === 0) {
                    promise.resolve();
                }
            });
        });

        return promise;
    }

    resolve(res?, ...args:any[]):JQueryDeferred<any> {
        return this.def.resolve(res, args);
    }

    reject(res?, ...args:any[]):JQueryDeferred<any> {
        return this.def.reject(res, args);
    }

    promise():JQueryPromise<any> {
        return this.def.promise();
    }

    done(cb):JQueryDeferred<any> {
        return this.def.done(cb);
    }

    then(ok, fail?):JQueryPromise<any> {
        return this.def.then(ok, fail);
    }

    always(cb):JQueryDeferred<any> {
        return this.def.always(cb);
    }

    state():string {
        return this.def.state();
    }
}


export default Deferred;


// WEBPACK FOOTER //
// ./src/ui/core/application/Deferred.ts